import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { recommendEventActions } from '../../../store/modules/recommend/event';
import RecommendEventDetailWrap from '../../../views/recommend/event/detail/RecommendEventDetailWrap';

class RecommendEventDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendEventId) => {
    const { getRecommendEventDetail } = this.props;

    getRecommendEventDetail({
      recommendEventId,
    });
  };

  render() {
    const { recommendEventDetail } = this.props;

    return <RecommendEventDetailWrap recommendEventDetail={recommendEventDetail} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendEventDetail: state.recommendEvent.recommendEventDetail,
  };
};

const mapDispatchToProps = {
  getRecommendEventDetail: recommendEventActions.getRecommendEventDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RecommendEventDetailContainer));
